module.exports = __webpack_public_path__ + "img/mockup.4aee34bd.png";